import React from 'react';
import { mui } from '~/tools/mui';
import { jss } from '~/tools/jss';
import { SurveyColumn } from '~/interfaces/survey.interface';

const useStyles = jss.makeStyles(() => ({
  headerCell: {
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
  },
}));

const defaultSortingState = {
  orderBy: null,
  order: 'asc',
};

type SortableTableHeadProps = {
  columns: SurveyColumn[];
  orderBy: string | null;
  order?: 'asc' | 'desc';
  onChangeSorting?: Function;
};

const SortableTableHead = ({
  columns,
  onChangeSorting = () => {},
  orderBy = defaultSortingState.orderBy,
  // @ts-ignore @TODO Epic WT-21600
  order = defaultSortingState.order,
}: SortableTableHeadProps) => {
  const classes = useStyles();

  const handleChangeSorting = (col) => {
    if (!col.allowSort) return;

    const isSortedByColumn = orderBy === col.orderBy;
    const isAsc = order === 'asc';

    let newSort = {
      orderBy: col.orderBy,
      order: 'asc',
    };

    if (isSortedByColumn && isAsc) {
      newSort.order = 'desc';
    } else if (isSortedByColumn) {
      newSort = defaultSortingState;
    }

    onChangeSorting(newSort);
  };

  return (
    <mui.TableHead data-testid="main-heading">
      <mui.TableRow>
        {columns?.length &&
          columns.map((col, index) => {
            const cellValue = col.headerName;
            const cellComponent = col?.renderHeader?.();

            const content = cellComponent || cellValue;
            const headerClassName = jss.combineStyles(classes.headerCell, col?.headerClassName);

            return (
              <mui.TableCell key={`header-${index}`} className={headerClassName}>
                {!col.allowSort && content}
                {col.allowSort && (
                  <mui.TableSortLabel
                    active={orderBy === col.orderBy}
                    direction={order}
                    onClick={() => handleChangeSorting(col)}
                  >
                    {content}
                  </mui.TableSortLabel>
                )}
              </mui.TableCell>
            );
          })}
      </mui.TableRow>
    </mui.TableHead>
  );
};

export default SortableTableHead;
